import { createPortal } from "preact/compat";

export function FloatingPortal({ children }) {
  return createPortal(children, document.body);
}
